(() => {
  window.GORGIASCHAT_DISABLE_AUTO_OPEN = true;

  const triggerSelector = '[data-gorgias-chat-open], [data-footer-chat-open]';
  const launcherSelector = '#gorgias-chat-container #chat-button, #chat-button';
  const fallbackDelay = 1600;
  let hideLauncherQueued = false;

  const hideLauncher = () => {
    document.querySelectorAll(launcherSelector).forEach((launcher) => {
      launcher.style.setProperty('display', 'none', 'important');
      launcher.style.setProperty('visibility', 'hidden', 'important');
      launcher.style.setProperty('pointer-events', 'none', 'important');
      launcher.setAttribute('aria-hidden', 'true');
      launcher.setAttribute('tabindex', '-1');
    });
  };

  const queueHideLauncher = () => {
    if (hideLauncherQueued) return;

    hideLauncherQueued = true;
    window.requestAnimationFrame(() => {
      hideLauncherQueued = false;
      hideLauncher();
    });
  };

  const waitForGorgias = () => {
    if (window.GorgiasChat) {
      return typeof window.GorgiasChat.init === 'function'
        ? window.GorgiasChat.init()
        : Promise.resolve();
    }

    return new Promise((resolve) => {
      window.addEventListener('gorgias-widget-loaded', () => {
        resolve(typeof window.GorgiasChat?.init === 'function' ? window.GorgiasChat.init() : undefined);
      }, { once: true });
    });
  };

  const openChat = (fallbackUrl = '') => {
    const fallbackTimer = fallbackUrl
      ? window.setTimeout(() => {
        window.location.href = fallbackUrl;
      }, fallbackDelay)
      : null;

    waitForGorgias()
      .then(() => {
        if (fallbackTimer) window.clearTimeout(fallbackTimer);
        hideLauncher();

        if (typeof window.GorgiasChat?.open === 'function') {
          window.GorgiasChat.open();
        } else if (fallbackUrl) {
          window.location.href = fallbackUrl;
        }
      })
      .catch(() => {
        if (fallbackUrl) window.location.href = fallbackUrl;
      });
  };

  const bindTriggers = () => {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(triggerSelector);

      if (!trigger) return;

      event.preventDefault();
      openChat(trigger.href || trigger.dataset.gorgiasChatFallback || '');
    });
  };

  const observeLauncher = () => {
    hideLauncher();

    const observer = new MutationObserver(queueHideLauncher);
    observer.observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener('gorgias-widget-loaded', hideLauncher);
    window.addEventListener('load', hideLauncher);
  };

  bindTriggers();
  observeLauncher();
})();
